import { z } from 'zod'

export const credentialsSchema = z.object({
  token: z.string().min(1).optional(),
  email: z.email(),
  htcToken: z.string().min(1),
  expiredAt: z.number().optional(),
})

export const credentialsTokensSchema = credentialsSchema.pick({ token: true, htcToken: true })

export const loginStatusSchema = z.object({
  retry_after: z.number(),
  reticulum_token: z.string(),
  is_new_user: z.boolean(),
  htc_account_access_token: z.string().min(1),
  email: z.email(),
})

export const invalidSessionResponseSchema = z.object({ code: z.literal('invalid_session') }).strict()

const profileSchema = z.object({
  id: z.string().min(1),
  displayName: z.string().min(1),
  walletAddress: z.string().min(1),
  accountEmail: z.email(),
  accountPhoneNumber: z.string().min(1),
  isOver18: z.boolean().nullable(),
  userId: z.string().min(1),
  activeAvatar: z.object({
    id: z.string().min(1),
    snapshot: z.string().min(1),
    glbUrl: z.string().min(1),
    dataType: z.number(),
    gender: z.number(),
    isHalfBody: z.boolean(),
  }),
})

export const profileIdSchema = profileSchema.pick({ id: true })
export const profileUserIdSchema = profileSchema.pick({ userId: true })
export const profileAvatarSchema = profileSchema.pick({ activeAvatar: true, displayName: true })
